import { render, staticRenderFns } from "./NavSideMain.vue?vue&type=template&id=41538c72&scoped=true"
import script from "./NavSideMain.js?vue&type=script&lang=js&external"
export * from "./NavSideMain.js?vue&type=script&lang=js&external"
import style0 from "./NavSideMain.scss?vue&type=style&index=0&id=41538c72&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41538c72",
  null
  
)

export default component.exports